const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};


let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {
      callback(data);
    });
  }
}


function formatMoney(cents, format) {
    format = `${format}{{amount}}`
    if (typeof cents == "string") {
      cents = cents.replace(".", "");
    }
    let value = "";
    let placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    let formatString = format || this.money_format;
  
    function defaultOption(opt, def) {
      return typeof opt == "undefined" ? def : opt;
    }
  
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ",");
      decimal = defaultOption(decimal, ".");
  
      if (isNaN(number) || number == null) {
        return 0;
      }
  
      number = (number / 100.0).toFixed(precision);
  
      let parts = number.split("."),
        dollars = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          "$1" + thousands
        ),
        cents = parts[1] ? decimal + parts[1] : "";
  
      return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
        case "amount":
            value = formatWithDelimiters(cents, 2);
            break;
        case "amount_no_decimals":
            value = formatWithDelimiters(cents, 0);
            break;
        case "amount_with_comma_separator":
            value = formatWithDelimiters(cents, 2, ".", ",");
            break;
        case "amount_no_decimals_with_comma_separator":
            value = formatWithDelimiters(cents, 0, ".", ",");
            break;
    }
  
    return formatString.replace(placeholderRegex, value);
}

class scaleImageToContent extends HTMLElement {
    constructor() {
        super();
        this.scaleImage();
        this.resizeElements();
    }
    resizeElements() {
        window.addEventListener('resize', () => {
            this.scaleImage();
        });
    }
    desktopScreenSize() {
        return window.innerWidth > 1200;
    }
    scaleImage() {
        const { image, content } = this.imageComponents();
        const contentHeight = content.offsetHeight;
        if(this.desktopScreenSize()) {
            image.style.height = `${contentHeight}px`;
        } else {
            image.style.height = '';
        }
    }
    imageComponents() {
        const image = this.querySelector('.image-container');
        const content = this.querySelector('.content-container');

        return { image, content };
    }
}

customElements.define('scale-image-to-content', scaleImageToContent);